/* Resources hub — local guide filter. No network, no storage. */
(function () {
  var form = document.querySelector('[data-resource-search]');
  if (!form) return;
  var input = form.querySelector('input[type="search"]');
  var count = document.getElementById('resource-search-count');
  var items = Array.prototype.slice.call(document.querySelectorAll('[data-search-item]'));
  var empty = document.querySelector('[data-search-empty]');
  var clears = document.querySelectorAll('[data-search-clear]');
  var total = items.length;

  function norm(s) { return (s || '').toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim(); }
  var index = items.map(function (el) { return norm(el.textContent + ' ' + (el.getAttribute('data-search-text') || '')); });

  function apply() {
    var terms = norm(input.value).split(' ').filter(Boolean);
    var shown = 0;
    items.forEach(function (el, i) {
      var match = terms.every(function (t) { return index[i].indexOf(t) !== -1; });
      el.hidden = !match;
      if (match) shown++;
    });
    if (empty) empty.hidden = shown !== 0;
    clears[0] && (clears[0].hidden = terms.length === 0);
    count.textContent = terms.length === 0
      ? 'Showing all ' + total + ' guides'
      : shown === 0 ? 'No guides match "' + input.value.trim() + '"'
      : 'Showing ' + shown + ' of ' + total + ' guide' + (total === 1 ? '' : 's');
  }
  input.addEventListener('input', apply);
  input.addEventListener('keydown', function (e) { if (e.key === 'Escape' && input.value) { input.value = ''; apply(); } });
  Array.prototype.forEach.call(clears, function (b) {
    b.addEventListener('click', function () { input.value = ''; apply(); input.focus(); });
  });
  apply();
})();
